// Mock data for Pups & Dreams Spa & Academy

export const businessInfo = {
  name: "Pups & Dreams Spa & Academy Ltd",
  tagline: "Luxury Grooming & Dog Grooming Training in Denton",
  description: "Professional care, loving hands, and expert training for your pooch.",
  phone: "07592 222056",
  email: "pupsanddreamsltd@outlook.com",
  address: {
    street: "65 Manchester Road",
    city: "Denton, Manchester",
    postcode: "M34 2AF",
    full: "65 Manchester Road, Denton, Manchester, M34 2AF"
  },
  hours: {
    weekdays: "Mon–Fri: 9am–6pm",
    saturday: "Saturday: 9am–3pm",
    sunday: "Sunday: Closed"
  },
  rating: {
    stars: 4.9,
    count: 190
  },
  mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2376.234567890123!2d-2.1234567890123456!3d53.456789012345678!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNTPCsDI3JzI0LjQiTiAywrAwNycyNC40Ilc!5e0!3m2!1sen!2suk!4v1234567890123!5m2!1sen!2suk"
};

export const services = [
  {
    id: 1,
    name: "Full Groom",
    description: "Complete grooming package including bath, blow dry, brush out, nail trim, ear cleaning, and breed-specific styling.",
    icon: "scissors",
    duration: "2-3 hours",
    priceRange: "From £35"
  },
  {
    id: 2,
    name: "Puppy Introduction Groom",
    description: "Gentle first grooming experience for puppies. Building confidence and positive associations with grooming.",
    icon: "heart",
    duration: "1-1.5 hours",
    priceRange: "From £25"
  },
  {
    id: 3,
    name: "Bath & Blow Dry",
    description: "Luxury bath with premium products, followed by professional blow dry and brush out.",
    icon: "droplet",
    duration: "1-2 hours",
    priceRange: "From £25"
  },
  {
    id: 4,
    name: "De-shedding Treatment",
    description: "Special treatment to remove loose undercoat and reduce shedding at home.",
    icon: "sparkles",
    duration: "Add-on service",
    priceRange: "From £10"
  },
  {
    id: 5,
    name: "Teeth Cleaning (Emmi-Pet)",
    description: "Gentle ultrasonic teeth cleaning system. No stress, no sedation required.",
    icon: "smile",
    duration: "15-20 mins",
    priceRange: "From £15"
  },
  {
    id: 6,
    name: "Nail & Hygiene Care",
    description: "Nail trimming, paw pad care, and hygiene trim for sensitive areas.",
    icon: "paw-print",
    duration: "20-30 mins",
    priceRange: "From £10"
  }
];

export const courseDetails = {
  title: "CPD Accredited Introduction to Dog Grooming",
  accreditation: "CPD Accredited",
  duration: "5 Day Course",
  schedule: "Mon–Fri, 10am–4pm",
  classSize: "Maximum 4 students",
  requirements: "No experience needed (18+)",
  starterKitValue: "£800",
  features: [
    "Real salon environment training",
    "Hands-on practical experience",
    "Small class sizes for individual attention",
    "Professional starter kit worth £800",
    "Business advice & ongoing support",
    "CPD Accredited certification",
    "WhatsApp support group",
    "CPD Accredited in-house certificate"
  ],
  curriculum: [
    "Dog health & anatomy",
    "Salon health & safety essentials",
    "Equipment: types, uses, maintenance",
    "Pre-groom assessment & products",
    "Bathing, drying & brushing techniques",
    "Nail trimming, ear cleaning & hygiene trims",
    "Clipping & scissoring techniques",
    "Breed specific styling basics",
    "Understanding matting",
    "De-shedding (long & short hair)",
    "Client consultation & aftercare",
    "Dog grooming business tips & advice"
  ]
};

export const teamMembers = [
  {
    id: 1,
    name: "Emily",
    role: "Co-owner & Amcademy Trainer",
    qualifications: "IPET Level 3 Qualified",
    background: "Former teacher",
    dogs: "Buddy & Bear",
    description: "Passionate about caring for every dog as if they were my own. I bring patience, love, and expertise to every groom.",
    story: "Emily studied English at university and went on to become a dedicated primary school teacher for six years. But everything changed during lockdown, when she welcomed two puppies into her life, and with them sparked a brand-new passion. In 2022, Emily swapped the classroom for the grooming table, combining her gentle nature, creativity, and love for dogs in a job she truly adores. Emily first started in her home salon, then went on to rent from a salon and doggy daycare.",
    image: "emily.jpeg"
  
  },
  {
    id: 2,
    name: "Megan",
    role: "Co-owner & Academy Trainer",
    qualifications: "Level 5 Diploma",
    background: "Dog lover and experienced groomer",
    dogs: "Bella, Bruce, Betsy & Bridget",
    description: "I love helping others start their grooming career. Every dog deserves to look and feel their best!",
    story: "Megan's journey has taken her through a wide range of roles; from studying makeup and psychology, to working in care, cleaning and education. While each job taught her something new, she was still searching for something that truly sparked her passion. In 2021, that changed the moment she picked up the clippers and stepped into the world of dog grooming. Megan started her business at home, has rented from 2 salons and also ran her own doggy daycare. As well as being a passionate dog stylist, Megan is a loving mum to Max and dog mum to 4 beautiful pooches.",
    image: "megan.jpeg"
  }
];

export const reviews = [
  {
    id: 1,
    author: "Shaun",
    rating: 5,
    text: "Due to house moves Chester has been to a few groomers over the last 18 months or so, but we've definitely found a keeper with Megan! He somehow looks better every time he's been, we love his cut from the day he's been and for the whole 8 weeks until his next appointment.",
    date: "2 weeks ago"
  },
  {
    id: 2,
    author: "Sylwia Giertuga",
    rating: 5,
    text: "Emily is absolutely amazing! Our pup Bryan always comes back from his grooming sessions looking smashing — clean, tidy, and so handsome. She has such a gentle, caring way with him, and it's clear she truly loves what she does. Bryan is always excited to see her, which says everything about how well she treats him.",
    date: "3 months ago"
  },
  {
    id: 3,
    author: "Sandra Bolton",
    rating: 5,
    text: "Megan as just only been grooming marley since early December, I was unsure at first having to look for a new groomer as last one closed down. Well I should not have worried after his first visit I could tell everything was going to be OK, you could see how she loved the dogs I knew marley would be OK.",
    date: "2 weeks ago"
  },
  {
    id: 4,
    author: "Victoria Daulby",
    rating: 5,
    text: "Can't recommend highly enough Emily and Megan at Pups & Dreams. They treat your pooch like their own. My handsome boy loves going in for a groom and cuddles and he always returns looking just perfect! Amazing experience from the loveliest ladies, from start to finish!",
    date: "6 months ago"
  },
  {
    id: 5,
    author: "Sarah Lockwood",
    rating: 5,
    text: "We took our dog Walter for his puppy groom and his first proper cut, with Megan at Pups and Dreams, and I honestly couldn't be happier with the experience. Megan is fantastic — she treats the dogs like they're her own, and it really shows. Walter absolutely loves her!",
    date: "1 week ago"
  },
  {
    id: 6,
    author: "Louise Rendall",
    rating: 5,
    text: "Meg did a fantastic job of grooming my little puppy Leo! It was his first time he came out looking amazing and so relaxed we will be going here for our regular grooms. Megan is a lovely person to! She adores dogs.",
    date: "2 months ago"
  },
  {
    id: 7,
    author: "Lindsay",
    rating: 5,
    text: "We changed our puppy groomer to Megan and from the beginning she greeted him, got down to his level and was just amazing, we were put at ease straightaway. She did an amazing job of his first 'big boy cut' and he is so relaxed and happy to go to her.",
    date: "6 months ago"
  },
  {
    id: 8,
    author: "Vincenzo Caponnetto",
    rating: 5,
    text: "I've known Megan for about four years now and honestly, I wouldn't trust anyone else with my Bruno. She's super professional but also really kind and caring, Bruno loves her and he's not the easiest dog when it comes to grooming.",
    date: "9 months ago"
  },
  {
    id: 9,
    author: "Dale Hall",
    rating: 5,
    text: "My puppy's been to her 3 times now, the first time she was refusing to even go in the shop but Megan made her feel so comfortable and at ease and now she cries to go in the shop and is over the moon when she sees Megan. 100% will never go anywhere else, the absolute best!",
    date: "4 months ago"
  },
  {
    id: 10,
    author: "Chloe Jones",
    rating: 5,
    text: "Absolutely amazing experience! After a complete nightmare with our dog's ears, she didn't just groom them beautifully — she gave the most professional, reassuring and genuinely helpful advice. The Pooch Parlour is hands-down the most beautiful grooming salon we've ever visited!",
    date: "3 months ago"
  }
];

export const hallOfFame = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1723059375155-af5e4a2f4df1?w=600",
    dogName: "Max & Buddy",
    breed: "Golden Retrievers"
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1559190394-df5a28aab5c5?w=600",
    dogName: "Charlie",
    breed: "Golden Retriever"
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1534361960057-19889db9621e?w=600",
    dogName: "Bella",
    breed: "Bichon Frise"
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1632498301446-5f78baad40d0?w=600",
    dogName: "Luna",
    breed: "Mixed Breed"
  },
  {
    id: 5,
    image: "https://images.unsplash.com/photo-1587402092301-725e37c70fd8?w=600",
    dogName: "Daisy",
    breed: "Pomeranian"
  },
  {
    id: 6,
    image: "https://images.unsplash.com/photo-1535930749574-1399327ce78f?w=600",
    dogName: "Oscar",
    breed: "Terrier Mix"
  },
  {
    id: 7,
    image: "https://images.unsplash.com/photo-1541364983171-a8ba01e95cfc?w=600",
    dogName: "Ruby",
    breed: "Pug"
  },
  {
    id: 8,
    image: "https://images.unsplash.com/photo-1546447147-3fc2b8181a74?w=600",
    dogName: "Cooper",
    breed: "Labrador"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "4.9★ Rated Excellence",
    description: "190+ happy customers trust us with their beloved pets",
    icon: "star"
  },
  {
    id: 2,
    title: "Qualified Groomers",
    description: "IPET Level 3 & Level 5 qualified professionals",
    icon: "award"
  },
  {
    id: 3,
    title: "Modern Spa Environment",
    description: "Clean, comfortable, and stress-free facilities",
    icon: "home"
  },
  {
    id: 4,
    title: "Gentle & Caring",
    description: "Perfect for nervous dogs and puppies",
    icon: "heart"
  },
  {
    id: 5,
    title: "Free Photo",
    description: "Cute photo of your dog after every grooming session",
    icon: "camera"
  },
  {
    id: 6,
    title: "CPD Accredited Academy",
    description: "Professional training for aspiring groomers",
    icon: "graduation-cap"
  }
];

// Mock booking slots (in real app, this would come from backend)
export const generateMockBookingSlots = (date) => {
  const slots = [
    "09:00 AM", "10:00 AM", "11:00 AM", "12:00 PM",
    "01:00 PM", "02:00 PM", "03:00 PM", "04:00 PM", "05:00 PM"
  ];
  
  // Return all slots as available (mock data)
  return slots.map(time => ({
    time,
    available: Math.random() > 0.3 // 70% chance of being available
  }));
};
